<script setup>
import DateTime from "../Helpers/DateTime";
import Arr from "../../Helpers/Arr";
import Api from "../../Helpers/Api";
import FeaturedImage from "../../Helpers/FeaturedImage";
import SortableSchedules from "../Helpers/SortableSchedules";
import Variable from "../../Helpers/Variable";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
const props = defineProps({
    schedules: SortableSchedules,
    hasAnySchedule: Boolean,
});
</script>

<template>
    <section v-if="Variable.notEmpty(schedules) && Variable.notEmpty(schedules.getGroupedSchedules())">
        <div v-for="(group, date) in schedules.getGroupedSchedules()">
            <span><span></span>{{ date }}</span>
            <ul>
                <li v-for="schedule in Arr.sortByTimeKey(group, 'start')">
                    <div>
                        <div>
                            <h1>{{ schedule['title'] }}</h1>
                            <div>
                                <span v-if="schedule['stage']">
                                    <img :src="new Api().mountImageRootPath('localization.svg')"
                                         alt="Localization icon">
                                    {{ schedule['stage'] }}
                                </span>
                                <span>
                                    <img :src="new Api().mountImageRootPath('clock.svg')" alt="Clock icon">
                                    {{ DateTime.schedulePeriodHumanReadable(schedule) }}
                                </span>
                            </div>
                            <ul>
                                <li v-for="tag in schedule.tags">
                                    <span>{{ tag }}</span>
                                </li>
                            </ul>
                        </div>
                        <ul>
                            <li v-for="speaker in schedule['speakers']">
                                <figure>
                                    <picture>
                                        <img :src="FeaturedImage.getSpeakerFeaturedImageUrl(speaker)" alt="">
                                    </picture>
                                </figure>
                                <div>
                                    <a :href="speaker['share_url']"><h3>{{ speaker['name'] }}</h3></a>
                                    <h4>{{ speaker['bio'] }}<br><b>{{ speaker['company'] }}</b></h4>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </section>
    <section v-else-if="hasAnySchedule"><h3>{{ t('Nenhuma palestra encontrada!')}}</h3></section>
    <section v-else><h3>{{ t('Disponível em breve!')}}</h3></section>
</template>
